'use strict';

import contactMap from './contactMap';

export default function contactView() {
    contactMap();
}
